import React, {Component, createContext, useState} from "react";
import Notification from "../components/Notification";

export const Context = createContext({});

let timeout;

const Provider = React.forwardRef((props, ref) => {

    const [status, setStatus] = useState(false);
    const [color, setColor] = useState('error');
    const [message, setMessage] = useState('');

    const notify = ({message, color = 'error', time = 3000}) => {
        setStatus(false);
        setTimeout(() => {
            if(timeout) {
                clearTimeout(timeout);
            }
            setMessage(message);
            setColor(color);
            setStatus(true);
            timeout = setTimeout(() => setStatus(false), time)
        }, 300)
    };

    const close = () => {
        setStatus(false)
    };

    const notificationContext = {
        status,
        color,
        message,
        notify,
        close,
        ref
    };

    return <Context.Provider value={notificationContext}>
        {props.children}
        <Notification
            color={color}
            anchorOrigin={{vertical: "top", horizontal: "right"}}
            open={status}
            ContentProps={{
                "aria-describedby": "message-id",
            }}
            message={
                <span id="message-id">
                    {message}
                </span>
            }
        />
    </Context.Provider>;
});

export const NotificationProvider = Provider;

const {Consumer} = Context;

export const withNotification = (Child) => class WithNotification extends Component {
    render() {
        return <Consumer>
            {
                notification => <Child {...this.props} notification={notification}/>
            }
        </Consumer>
    }
};


